module.exports = __webpack_public_path__ + "static/img/图形.9d95d08.png";


//////////////////
// WEBPACK FOOTER
// ./static/ningbo/ningbo_log/图形.png
// module id = jtan
// module chunks = 24